// removed by extract-text-webpack-plugin
module.exports = {"this":"InlineBlock__this___3VR2L","fullWidth":"InlineBlock__fullWidth___1EPX6","fullHeight":"InlineBlock__fullHeight___2i0Ft","alignTop":"InlineBlock__alignTop___3SxI4","alignMiddle":"InlineBlock__alignMiddle___3YqpH","alignBottom":"InlineBlock__alignBottom___29Hr3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/InlineBlock.css
// module id = 1255
// module chunks = 4